export default [
  {
    path: 'create/',
    name: 'ControlPanelInvoiceAdd',
    meta: {
      title: 'Add Invoice',
      masterModal: 'create'
    },
    children: [
      {
        path: ':customerId',
        name: 'ControlPanelInvoiceAddCustomer',
        meta: {
          title: 'Add Invoice',
          masterModal: 'create',
        }
      },
      {
        path: ':customerId/:projectId',
        name: 'ControlPanelInvoiceAddProject',
        meta: {
          title: 'Add Invoice',
          masterModal: 'create',
        }
      }
    ]
  },
  {
    path: 'edit/:invoiceId',
    name: 'ControlPanelInvoiceEdit',
    meta: {
      title: 'Edit Invoice',
      masterModal: 'edit'
    }
  },
  {
    path: 'view/:invoiceId',
    name: 'ControlPanelInvoiceView',
    meta: {
      title: 'View Invoice',
      masterModal: 'view'
    }
  },
  {
    path: 'view/:invoiceId/recurrent',
    name: 'ControlPanelInvoiceViewRecurrent',
    meta: {
      title: 'View Invoice',
      masterModal: 'view',
      recurrent: true
    }
  },
  // {
  //   path: 'send/:invoiceId/recurrent',
  //   name: 'ControlPanelInvoiceSendRecurrent',
  //   meta: {
  //     title: 'Send Invoice',
  //     masterModal: 'send',
  //     recurrent: true
  //   }
  // },
  {
    path: 'send/',
    name: 'ControlPanelInvoiceSendHome',
    meta: {
      title: 'Send Invoices',
      masterModal: 'send'
    },
    children: [
      {
        path: ':invoiceId',
        name: 'ControlPanelInvoiceSend',
        meta: {
          title: 'Send Invoices',
          masterModal: 'send'
        }
      },
      {
        path: ':invoiceId/:emailMessageId',
        name: 'ControlPanelInvoiceSend',
        meta: {
          title: 'Send Invoices',
          masterModal: 'send'
        }
      },
    ]
  },
  {
    path: 'upload/',
    name: 'ControlPanelInvoiceUpload',
    meta: { title: 'Upload to Invoices', showUploadModal: true, modalType: 'upload' },
    children: [
      {
        path: 'invoice/add', name: 'ControlPanelInvoiceUploadInvoice',
        meta: {
          title: 'Upload Invoice',
          showUploadModal: true,
          modalType: 'upload',
          uploadType: 'invoice'
        }
      },
      {
        path: 'correction/add', name: 'ControlPanelInvoiceUploadCorrection',
        meta: {
          title: 'Upload Correction',
          showUploadModal: true,
          modalType: 'upload',
          uploadType: 'correction'
        }
      },
      {
        path: 'edit/:invoiceId',
        name: 'ControlPanelInvoiceEdit',
        meta: {
          title: 'Edit Invoice',
          masterModal: 'edit'
        }
      },
      {
        path: 'payment/:invoiceId',
        name: 'ControlPanelInvoicePayments',
        meta: {
          title: 'Invoice payments',
          masterModal: 'payments'
        }
      },
    ]
  },
]
